export default "__VITE_ASSET__22640073__"